import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add prefers-reduced-motion styles
const reducedMotionStyles = document.createElement('style');
reducedMotionStyles.innerHTML = `
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
document.head.appendChild(reducedMotionStyles);
render(<App data-id="element-85" />, document.getElementById('root'));